import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./RTK/store";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { initializeToken } from "./RTK/Slices/Slices/apiSliceMeat";
import { CartProvider } from "./Context/CartContext";
import ThemeProvider from "./Context/ThemeProvider";
import { cleanupExpiredData } from "./utils/localStorage";
import VacationGuard from "./Components/VacationGuard";
import Loader2 from "./Components/Loader2";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cleanupInterval: string | number | NodeJS.Timer | undefined;

    const init = async () => {
      await initializeToken(); // انتظر جلب أو تجديد الـ token
      cleanupExpiredData(30); // تنظيف البيانات المنتهية

      // تكرار التنظيف كل 24 ساعة
      cleanupInterval = setInterval(() => {
        cleanupExpiredData(30);
      }, 24 * 60 * 60 * 1000);

      setLoading(false); // بعد التهيئة أوقف التحميل
    };

    init();

    // تنظيف الـ interval عند إزالة المكون
    return () => {
      if (cleanupInterval) clearInterval(cleanupInterval);
    };
  }, []);

  if (loading) return <Loader2 />;

  return (
    <Provider store={store}>
      <ThemeProvider>
        <CartProvider>
          <VacationGuard>
            <RouterProvider router={router} />
          </VacationGuard>
        </CartProvider>
      </ThemeProvider>
    </Provider>
  );
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
